import { useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useDispatch, useSelector } from 'react-redux';
import { printDialog } from '../common/slice/printDialog';
import ProdToPrint from './ProdToPrint';

const Print = ({ prod, params }) => {
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const dispatch = useDispatch();
  const { visible } = useSelector((state) => state.printDialog);

  useEffect(() => {
    if (visible) {
      handlePrint();
      dispatch(printDialog.actions.reset());
    }
  }, [visible]);

  return (
    <>
      <div style={{ display: 'none' }}>
        <ProdToPrint ref={printRef} prod={prod} params={params} />
      </div>
      <div className="print-prod-card" onClick={handlePrint}>
        <i className="icon printer"></i>
        <span>Распечатать карточку товара</span>
      </div>
    </>
  );
};

export default Print;
